import { useDispatch, useSelector } from 'react-redux';
import { createSlice } from '@reduxjs/toolkit';
import { useInjectReducer } from '../../store/useInjectReducer';

// Dynamic Redux Slice definition for Injection
export const dynamicCounterSlice = createSlice({
  name: 'dynamicCounter',
  initialState: { value: 42 },
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
  },
});

export const useInjectedCounter = () => {
  // Inject reducer slice dynamically on hook mount
  useInjectReducer({ key: 'dynamicCounter', reducer: dynamicCounterSlice.reducer });
  
  const count = useSelector((state: any) => state.dynamicCounter?.value);
  const dispatch = useDispatch();

  const handleIncrement = () => {
    dispatch(dynamicCounterSlice.actions.increment());
  };

  const handleDecrement = () => {
    dispatch(dynamicCounterSlice.actions.decrement());
  };

  return {
    count,
    handleIncrement,
    handleDecrement,
  };
};
